import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';

interface Props {
  image: string;
  mobileImage?: string;
  title?: string;
  subtitle?: string;
  position?: 'top' | 'center' | 'bottom';
}

const HeroPrivatLeasing = ({
  image,
  title,
  subtitle,
  mobileImage,
  position = 'center',
}: Props) => {
  const positionClass: Record<Props['position'], string> = {
    center: 'top-1/2 -translate-y-1/2',
    bottom: 'bottom-[86px]',
    top: 'top-[86px]',
  };
  return (
    <section
      className="relative flex w-full h-[80vh] max-h-[918] lg:max-h-[1018px] bg-cover bg-center lg:bg-[center_20%] text-white mb-14"
      style={{
        backgroundImage: `url(${image})`,
        backgroundColor: '#fafafa',
        ...(mobileImage && {
          '--tw-bg-mobile': `url(${mobileImage})`,
        }),
      }}
    >
      {(title || subtitle) && (
        <m.div
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={viewPort}
          className={`absolute text-center grid gap-1 text-white p-2 w-full left-1/2 -translate-x-1/2 ${positionClass[position]}`}
        >
          {title && (
            <m.h1
              variants={itemVariants}
              className="font-medium leading-tight whitespace-pre-line"
              style={{ fontSize: 'clamp(20px, 8vw, 72px)' }}
            >
              {title}
            </m.h1>
          )}
          {subtitle && (
            <m.p
              variants={itemVariants}
              className="text-xl sm:text-2xl leading-tight whitespace-pre-line"
            >
              {subtitle}
            </m.p>
          )}
        </m.div>
      )}
    </section>
  );
};

export default HeroPrivatLeasing;
